// ActivityItemV3 — single row inside the recent activity feed.
import React from "react";
import { Users, Send, Coins, Sparkles } from "lucide-react";

const ICONS = {
    lead: Users,
    campaign: Send,
    credits: Coins,
    system: Sparkles,
};

const COLORS = {
    lead: "#FFFFFF",
    campaign: "#CCCCCC",
    credits: "#A3A3A3",
    system: "#CCCCCC",
};

export default function ActivityItemV3({ testId, type, text, timeLabel }) {
    const Icon = ICONS[type] || Sparkles;
    const color = COLORS[type] || "#CCCCCC";
    return (
        <li
            data-testid={testId}
            className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-white/[0.02] transition-colors"
        >
            <span
                className="h-8 w-8 rounded-lg grid place-items-center shrink-0"
                style={{ backgroundColor: `${color}18` }}
            >
                <Icon className="h-4 w-4" style={{ color }} aria-hidden />
            </span>
            <p className="flex-1 min-w-0 text-sm text-[#FFFFFF] truncate">{text}</p>
            <span className="text-xs text-[#71717A] tabular-nums shrink-0">{timeLabel}</span>
        </li>
    );
}
